// tours/tourState.js
import { reactive } from 'vue';

export const tourRegistry = reactive({});
